import SMCcars from './SMCcars';

export default SMCcars;
